module.exports = __webpack_public_path__ + "img/verifiedvisa.046d21df.png";